import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { USER_SELECTION } from 'src/app/pages/core/models/DocumentFlow';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
})
export class StepComponent implements OnInit {
  @Output() stepChanged = new EventEmitter<USER_SELECTION>();

  @Input() title: string;
  @Input() subtitle: string;
  @Input() enableNextButton = false;
  @Input() nextButton = false;
  @Input() backButton = false;
  @Input() endButton = false;

  USER_SELECTION = USER_SELECTION;

  constructor() {}

  ngOnInit(): void {}

  selectResponse(value: USER_SELECTION) {
    this.stepChanged.emit(value);
  }
}
